import { createContext, Dispatch } from 'react';
import isFunction from 'lodash/isFunction';
 
export type dataType = {
    detailData: any;
};
 
export const initDetailData: dataType = {
    detailData: null
};
 
export type Actions = Partial<dataType> | ((draft: dataType) => void | dataType);
 
export const reducers = (state: dataType, action: Actions): dataType | void | undefined => {
    if(isFunction(action)){
        action(state);
        return;
    }
    return state;
} 
 
export const ContextNav:any = createContext(null);